var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaalplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.121,11.96l-1.5-.365,1.244-.315a.458.458,0,0,0-.226-.888l-2.916.741-3.041-.741a.458.458,0,0,0-.217.889l1.365.332-1.369.348a.458.458,0,0,0,.112.9.486.486,0,0,0,.113-.014l3.042-.772,3.17.773a.458.458,0,1,0,.218-.889Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.854,10.319c.082-.1-.565-.468-.647-1.2a2.433,2.433,0,0,1,.211-1.129,4.509,4.509,0,0,0,.316-.692c.106-.355-.087-.7-.024-.706.346-.055.465,1.3.632,1.3.2,0,.362-.719.422-1.22.115-.965-.112-1.568.06-1.641s.26.521.471.818a4.1,4.1,0,0,1,.888,1.927,2.769,2.769,0,0,1-.151,1.506c-.289.67-.8.966-.737,1.054a2.37,2.37,0,0,0,1.426-.668,2.773,2.773,0,0,0,.738-1.415A3.752,3.752,0,0,0,10.1,5.91a7.5,7.5,0,0,0-1.16-1.717c-.43-.543-1.613-2.036-1.927-1.851-.07.041-.062.146-.075.316a4.5,4.5,0,0,1-.542,1.475C5.885,5.207,5.727,5.209,5.325,6.09a3.736,3.736,0,0,0-.512,1.747,2.608,2.608,0,0,0,.512,1.505C5.826,10,6.77,10.423,6.854,10.319Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaalplads);
export default __webpack_public_path__ + "static/media/BAALPLADS.ace1f2e080d702cb82111ea37c8701ee.svg";
export { ForwardRef as ReactComponent };